var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42871 5L18.5716 18.3571",
    stroke: "currentColor",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5424 13.9242C13.9467 14.4657 13.1602 14.7483 12.3561 14.71C11.5519 14.6717 10.7959 14.3155 10.2543 13.7198C9.71277 13.1241 9.43002 12.3376 9.46828 11.5335C9.50653 10.7293 9.86266 9.97325 10.4583 9.43164",
    stroke: "currentColor",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40137 7.16992C5.30727 8.73677 4 11.6784 4 11.6784C4 11.6784 6.42857 17.1421 12.5 17.1421C13.9225 17.1535 15.3273 16.8258 16.598 16.1863",
    stroke: "currentColor",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.618 14.7969C20.2726 13.315 21.0003 11.6778 21.0003 11.6778C21.0003 11.6778 18.5717 6.2129 12.5003 6.2129C11.9745 6.21204 11.4494 6.25479 10.9307 6.34072",
    stroke: "currentColor",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0713 8.69727C13.7165 8.82116 14.3042 9.15092 14.7461 9.63707C15.1881 10.1232 15.4605 10.7396 15.5225 11.3936",
    stroke: "currentColor",
    strokeWidth: 1.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.f27396e4.svg";
export { ForwardRef as ReactComponent };